
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './thetypist-app-wasmApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
              case 'pointercancel':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'app.thetypist.core.data.storageGet' : (key) => { try { return globalThis.localStorage.getItem(key); } catch (e) { return null; } },
    'app.thetypist.core.data.storageSet' : (key, value) => { try { globalThis.localStorage.setItem(key, value); return true; } catch (e) { return false; } },
    'app.thetypist.core.data.randomBytesCsv' : (n) => { const a = new Uint8Array(n); crypto.getRandomValues(a); return Array.from(a).join(','); },
    'br.com.faru.boitata.core.clock.prefersReducedMotion' : () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    'app.thetypist.core.designsystem.probeCreate' : (onDone) => (() => {
          const probes = globalThis.__typistProbes || (globalThis.__typistProbes = { next: 0, all: {} });
          const id = probes.next++;
          const input = document.createElement('input');
          input.type = 'text';
          input.setAttribute('autocomplete', 'off');
          input.setAttribute('autocorrect', 'off');
          input.setAttribute('aria-label', 'Fit the typewriter keyboard');
          input.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;opacity:0.01;z-index:10;border:0;padding:0;margin:0;' +
            'background:transparent;color:transparent;caret-color:transparent;font-size:16px;outline:none;';
          input.addEventListener('input', () => { input.value = ''; });
          input.addEventListener('focus', () => {
            const vv = globalThis.visualViewport;
            const before = vv ? vv.height : innerHeight;
            let best = 0, steady = 0, waited = 0;
            const tick = () => {
              waited += 100;
              const shrink = before - (vv ? vv.height : innerHeight);
              if (shrink > best + 1) { best = shrink; steady = 0; } else if (best > 0) { steady += 100; }
              if ((best > 0 && steady >= 400) || waited >= 3000) {
                input.blur();
                onDone(best, innerWidth);
              } else {
                setTimeout(tick, 100);
              }
            };
            setTimeout(tick, 100);
          });
          document.body.appendChild(input);
          probes.all[id] = input;
          return id;
        })(),
    'app.thetypist.core.designsystem.__convertKotlinClosureToJsClosure_((Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Double,Double)->Unit)'](f, p0, p1)),
    'app.thetypist.core.designsystem.probeRemove' : (id) => {
          const probes = globalThis.__typistProbes;
          const input = probes && probes.all[id];
          if (input) { input.remove(); delete probes.all[id]; }
        },
    'app.thetypist.core.designsystem.probePlace' : (id, x, y, w, h) => {
          const input = globalThis.__typistProbes.all[id];
          if (!input) return;
          const r = globalThis.devicePixelRatio || 1;
          input.style.left = (x / r) + 'px'; input.style.top = (y / r) + 'px';
          input.style.width = (w / r) + 'px'; input.style.height = (h / r) + 'px';
        },
    'app.thetypist.core.designsystem.jsCoarsePointer' : () => (() => { try { return !!(globalThis.matchMedia && globalThis.matchMedia('(pointer: coarse)').matches); } catch (e) { return false; } })(),
    'app.thetypist.core.audio.jsAmbienceInit' : () => {
          const a = globalThis.__typistAudio;
          if (a.amb) return;
          a.amb = { layers: {}, targets: {}, muffled: false, bus: null };
          // Every layer through one lowpass and gain: the room as heard with headphones on.
          a.amb.output = () => {
            const ctx = a.ctx;
            if (!a.amb.bus) {
              const filter = ctx.createBiquadFilter();
              filter.type = 'lowpass';
              filter.Q.value = 0.7;
              filter.frequency.value = a.amb.muffled ? 700 : 20000;
              const gain = ctx.createGain();
              gain.gain.value = a.amb.muffled ? 0.4 : 1;
              filter.connect(gain);
              gain.connect(ctx.destination);
              a.amb.bus = { filter, gain };
            }
            return a.amb.bus.filter;
          };
          a.amb.headphones = (on) => {
            a.amb.muffled = on;
            const bus = a.amb.bus;
            if (!bus || !a.ctx) return;
            const t = a.ctx.currentTime;
            bus.filter.frequency.cancelScheduledValues(t);
            bus.filter.frequency.setTargetAtTime(on ? 700 : 20000, t, on ? 0.25 : 0.5);
            bus.gain.gain.cancelScheduledValues(t);
            bus.gain.gain.setTargetAtTime(on ? 0.4 : 1, t, on ? 0.25 : 0.5);
          };
          const start = (name) => {
            const l = a.amb.layers[name];
            if (!l || !l.buffer || l.source || !a.ctx) return;
            const ctx = a.ctx;
            l.gain = ctx.createGain();
            l.gain.gain.value = 0;
            l.gain.connect(a.amb.output());
            l.source = ctx.createBufferSource();
            l.source.buffer = l.buffer;
            l.source.loop = true;
            l.source.connect(l.gain);
            l.source.start();
            a.amb.apply(name);
          };
          a.amb.apply = (name) => {
            const l = a.amb.layers[name];
            if (!l || !l.gain) return;
            const t = a.ctx.currentTime;
            l.gain.gain.cancelScheduledValues(t);
            l.gain.gain.setValueAtTime(l.gain.gain.value, t);
            l.gain.gain.linearRampToValueAtTime(a.amb.targets[name] || 0, t + 2.5);
          };
          a.amb.start = start;
          const previous = a.onWake;
          a.onWake = () => { if (previous) previous(); Object.keys(a.amb.layers).forEach(start); };
        },
    'app.thetypist.core.audio.jsAmbienceSource' : (name, url) => {
          const a = globalThis.__typistAudio;
          const l = a.amb.layers[name];
          if (!l || l.url === url) return;
          // Whoever waits on the old recording is let go (the new one loads when needed).
          (l.waiting || []).forEach(f => f());
          l.waiting = [];
          if (l.source) {
            const old = l;
            if (a.ctx) { old.gain.gain.cancelScheduledValues(a.ctx.currentTime); old.gain.gain.setTargetAtTime(0, a.ctx.currentTime, 0.3); }
            setTimeout(() => { try { old.source.stop(); } catch (e) {} }, 1500);
          }
          delete a.amb.layers[name];
        },
    'app.thetypist.core.audio.jsAmbienceLoad' : (name, url, done) => {
          const a = globalThis.__typistAudio;
          const existing = a.amb.layers[name];
          if (existing) {
            if (existing.buffer) done(); else (existing.waiting = existing.waiting || []).push(done);
            return;
          }
          const l = a.amb.layers[name] = { url, buffer: null, source: null, gain: null, waiting: [done] };
          const finish = () => { const w = l.waiting || []; l.waiting = []; w.forEach(f => f()); };
          // MP3 encoders pad both ends with near-silence: cut it, or the loop gaps.
          const trim = (b) => {
            const d = b.getChannelData(0);
            let s = 0, e = d.length;
            while (s < e && Math.abs(d[s]) < 1e-4) s++;
            while (e > s && Math.abs(d[e - 1]) < 1e-4) e--;
            if (s === 0 && e === d.length) return b;
            const ctx = a.ctx || new (globalThis.OfflineAudioContext || globalThis.webkitOfflineAudioContext)(1, 1, b.sampleRate);
            const out = ctx.createBuffer(1, e - s, b.sampleRate);
            out.copyToChannel(d.subarray(s, e), 0);
            return out;
          };
          fetch(url)
            .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.arrayBuffer(); })
            .then(data => (a.ctx || new (globalThis.OfflineAudioContext || globalThis.webkitOfflineAudioContext)(1, 1, 44100)).decodeAudioData(data))
            .then(buffer => { l.buffer = trim(buffer); if (a.amb.layers[name] === l) a.amb.start(name); finish(); })
            .catch(() => { delete a.amb.layers[name]; finish(); });
        },
    'app.thetypist.core.audio.jsAmbienceLevel' : (name, level) => {
          const a = globalThis.__typistAudio;
          a.amb.targets[name] = level;
          if (a.ctx) a.amb.apply(name);
        },
    'app.thetypist.core.audio.jsAmbienceHeadphones' : (on) => globalThis.__typistAudio.amb.headphones(on),
    'app.thetypist.core.audio.jsAmbienceStop' : () => {
          const a = globalThis.__typistAudio;
          if (!a || !a.amb) return;
          Object.values(a.amb.layers).forEach(l => { try { if (l.source) l.source.stop(); } catch (e) {} });
          a.amb.layers = {};
        },
    'app.thetypist.core.audio.jsDictationInit' : () => {
          if (globalThis.__typistDictation) return;
          const d = { parts: [], durs: [], idx: 0, start: 0, end: null, el: null, status: 'Idle', err: '', rate: 1, want: false, metas: [], vol: 1, cors: true, wired: null, gain: null, an: null, levels: [], buf: null };
          // The voice through the shared AudioContext: a gain (volume, with a boost past 1) and an
          // analyser that hears its pauses. Needs the file served with CORS; without it the element
          // plays on its own, at most at full volume, and nothing is heard for pauses.
          const wire = () => {
            const a = globalThis.__typistAudio;
            const el = d.el;
            if (!el || !d.cors || d.wired === el || !a || !a.ctx) return;
            try {
              const ctx = a.ctx;
              if (!d.gain) {
                d.gain = ctx.createGain();
                d.an = ctx.createAnalyser();
                d.an.fftSize = 1024;
                d.buf = new Float32Array(d.an.fftSize);
                d.gain.connect(d.an);
                d.an.connect(ctx.destination);
              }
              ctx.createMediaElementSource(el).connect(d.gain);
              d.wired = el;
              el.volume = 1;
              d.gain.gain.value = d.vol;
            } catch (e) { d.cors = false; }
          };
          d.applyVolume = () => {
            if (d.wired && d.wired === d.el && d.gain) d.gain.gain.value = d.vol;
            else if (d.el) d.el.volume = Math.min(1, d.vol);
          };
          setInterval(() => {
            if (!d.el || d.el.paused || !d.an || d.wired !== d.el) return;
            d.an.getFloatTimeDomainData(d.buf);
            let sum = 0;
            for (let i = 0; i < d.buf.length; i++) sum += d.buf[i] * d.buf[i];
            // Heard after the gain: measured as the voice was recorded.
            const rms = Math.sqrt(sum / d.buf.length) / Math.max(0.05, d.vol);
            d.levels.push(Math.round(d.position() * 1000) + ':' + rms.toFixed(5));
            if (d.levels.length > 400) d.levels.shift();
          }, 20);
          const total = () => {
            if (d.durs.some(x => isNaN(x))) return NaN;
            const n = d.parts.length;
            let t = 0;
            for (let i = 0; i < n - 1; i++) t += d.durs[i];
            return t + (d.end != null ? d.end : d.durs[n - 1]) - d.start;
          };
          const before = (i) => { let t = 0; for (let k = 0; k < i; k++) t += (d.durs[k] || 0); return t; };
          const open = (i, local, play) => {
            if (d.el) { d.el.pause(); d.el.removeAttribute('src'); d.el.load(); }
            d.idx = i;
            const el = new Audio();
            el.preload = 'auto';
            el.preservesPitch = true;
            el.playbackRate = d.rate;
            if (d.cors) el.crossOrigin = 'anonymous';
            el.src = d.parts[i];
            el.addEventListener('play', () => wire());
            el.addEventListener('loadedmetadata', () => { try { el.currentTime = local; } catch (e) {} });
            el.addEventListener('canplay', () => { if (d.status === 'Loading') d.status = 'Paused'; if (d.want && el.paused) el.play().catch(() => {}); });
            el.addEventListener('error', () => {
              // Refused for CORS: open it again as a plain element.
              if (d.cors && el.crossOrigin) { d.cors = false; open(i, local, d.want); return; }
              d.status = 'NoRecording'; d.err = 'The recording could not be loaded';
            });
            el.addEventListener('ended', () => {
              if (d.idx + 1 < d.parts.length) open(d.idx + 1, 0, d.want);
              else { d.want = false; d.status = 'Paused'; }
            });
            d.el = el;
            wire();
            d.applyVolume();
            if (play) el.play().catch(() => {});
          };
          d.load = (urls, startMs, endMs, posMs) => {
            d.want = false;
            d.parts = urls.split('\n');
            d.durs = d.parts.map(() => NaN);
            d.start = startMs / 1000;
            d.end = endMs < 0 ? null : endMs / 1000;
            d.status = 'Loading';
            d.err = '';
            d.cors = true;
            d.levels = [];
            d.metas.forEach(a => a.removeAttribute('src'));
            d.metas = d.parts.map((u, i) => {
              const a = new Audio();
              a.preload = 'metadata';
              a.addEventListener('loadedmetadata', () => { d.durs[i] = a.duration; });
              a.src = u;
              return a;
            });
            open(0, d.start + posMs / 1000, false);
          };
          d.position = () => d.el ? before(d.idx) + d.el.currentTime - d.start : 0;
          d.seek = (ms) => {
            let target = d.start + ms / 1000;
            let i = 0;
            while (i < d.parts.length - 1 && !isNaN(d.durs[i]) && target >= d.durs[i]) { target -= d.durs[i]; i++; }
            if (i !== d.idx) open(i, target, d.want);
            else if (d.el) { try { d.el.currentTime = target; } catch (e) {} }
          };
          d.poll = () => {
            const el = d.el;
            let pos = d.position();
            const dur = total();
            if (el && d.end != null && d.idx === d.parts.length - 1 && el.currentTime >= d.end) { el.pause(); d.want = false; d.status = 'Paused'; pos = dur; }
            if (el && d.status !== 'Loading' && d.status !== 'NoRecording') d.status = d.want && !el.paused ? 'Playing' : 'Paused';
            let buffered = 0;
            if (el && el.buffered.length) buffered = before(d.idx) + el.buffered.end(el.buffered.length - 1) - d.start;
            let loading = 0;
            if (el && !isNaN(el.duration) && el.duration > 0 && el.buffered.length) loading = Math.min(1, el.buffered.end(el.buffered.length - 1) / Math.max(0.1, Math.min(el.duration, d.start + 60) ));
            const ms = (s) => isNaN(s) ? 0 : Math.max(0, Math.round(s * 1000));
            if (el && !el.paused) wire();
            const levels = d.levels.join(';');
            d.levels = [];
            return [d.status, ms(pos), ms(dur), ms(Math.min(buffered, isNaN(dur) ? buffered : dur)), loading.toFixed(3), d.err.replace(/\|/g, '/'), levels, d.wired && d.wired === el ? '1' : '0'].join('|');
          };
          globalThis.__typistDictation = d;
        },
    'app.thetypist.core.audio.jsDictationLoad' : (urls, startMs, endMs, positionMs) => globalThis.__typistDictation.load(urls, startMs, endMs, positionMs),
    'app.thetypist.core.audio.jsDictationPoll' : () => globalThis.__typistDictation.poll(),
    'app.thetypist.core.audio.jsDictationPlay' : () => { const d = globalThis.__typistDictation; d.want = true; if (d.el) d.el.play().catch(() => {}); },
    'app.thetypist.core.audio.jsDictationPause' : () => { const d = globalThis.__typistDictation; d.want = false; if (d.el) d.el.pause(); },
    'app.thetypist.core.audio.jsDictationSeek' : (ms) => globalThis.__typistDictation.seek(ms),
    'app.thetypist.core.audio.jsDictationRate' : (rate) => { const d = globalThis.__typistDictation; d.rate = rate; if (d.el) d.el.playbackRate = rate; },
    'app.thetypist.core.audio.jsDictationVolume' : (volume) => { const d = globalThis.__typistDictation; d.vol = volume; d.applyVolume(); },
    'app.thetypist.core.audio.jsInit' : () => {
          if (globalThis.__typistAudio) return;
          const a = globalThis.__typistAudio = { ctx: null, pending: [], buffers: [] };
          a.context = () => {
            if (!a.ctx) a.ctx = new (globalThis.AudioContext || globalThis.webkitAudioContext)({ latencyHint: 'interactive' });
            if (a.ctx.state === 'suspended') a.ctx.resume();
            return a.ctx;
          };
          const wake = () => { a.context(); if (a.onWake) a.onWake(); };
          for (const type of ['pointerdown', 'keydown', 'touchend']) globalThis.addEventListener(type, wake, { capture: true, passive: true });
        },
    'app.thetypist.core.audio.jsNewBuffer' : (length) => (globalThis.__typistAudio.pending.push(new Float32Array(length)), globalThis.__typistAudio.pending.length - 1),
    'app.thetypist.core.audio.jsSet' : (buffer, index, value) => { globalThis.__typistAudio.pending[buffer][index] = value; },
    'app.thetypist.core.audio.jsSeal' : (buffer, rate) => {
          const a = globalThis.__typistAudio;
          const data = a.pending[buffer];
          try {
            const b = new AudioBuffer({ numberOfChannels: 1, length: data.length, sampleRate: rate });
            b.copyToChannel(data, 0);
            a.buffers[buffer] = b;
            a.pending[buffer] = null;
          } catch (e) {
            // Very old browsers: built on first play instead.
          }
        },
    'app.thetypist.core.audio.jsPlay' : (buffer, rate) => {
          const a = globalThis.__typistAudio;
          const ctx = a.context();
          let b = a.buffers[buffer];
          if (!b) {
            const data = a.pending[buffer];
            b = ctx.createBuffer(1, data.length, rate);
            b.copyToChannel(data, 0);
            a.buffers[buffer] = b;
          }
          const source = ctx.createBufferSource();
          source.buffer = b;
          if (!a.keys) { a.keys = ctx.createGain(); a.keys.gain.value = a.keysLevel == null ? 1 : a.keysLevel; a.keys.connect(ctx.destination); }
          source.connect(a.keys);
          source.start();
        },
    'app.thetypist.core.audio.jsKeysLevel' : (level) => {
          const a = globalThis.__typistAudio;
          a.keysLevel = level;
          if (a.keys && a.ctx) a.keys.gain.setTargetAtTime(level, a.ctx.currentTime, 0.3);
        },
    'app.thetypist.core.audio.jsRelease' : () => { const a = globalThis.__typistAudio; if (a && a.ctx) a.ctx.close(); },
    'app.thetypist.core.audio.radio.jsRadioTune' : (urls, status) => {
          const a = globalThis.__typistAudio;
          let r = globalThis.__typistRadio;
          if (!r) {
            r = globalThis.__typistRadio = { gen: 0, el: null, volume: 0.7, effects: true, built: false };
            r.build = () => {
              if (r.built) return;
              const ctx = a.context();
              r.master = ctx.createGain(); r.master.gain.value = r.volume * r.volume * 0.9; r.master.connect(ctx.destination);
              // The cabinet speaker: nothing below 300 Hz or above 3.2 kHz, a little overdrive.
              r.hp = ctx.createBiquadFilter(); r.hp.type = 'highpass'; r.hp.frequency.value = 300; r.hp.Q.value = 0.71;
              r.lp = ctx.createBiquadFilter(); r.lp.type = 'lowpass'; r.lp.frequency.value = 3200; r.lp.Q.value = 0.9;
              r.shaper = ctx.createWaveShaper();
              const curve = new Float32Array(1024);
              for (let i = 0; i < 1024; i++) { const x = (i / 511.5) - 1; curve[i] = Math.tanh(1.7 * x) / Math.tanh(1.7); }
              r.shaper.curve = curve;
              r.music = ctx.createGain(); r.music.gain.value = 0;
              r.hp.connect(r.lp); r.lp.connect(r.shaper); r.shaper.connect(r.music); r.music.connect(r.master);
              // Hiss and pops: two looping buffers of noise, each through its own gain.
              const sr = ctx.sampleRate, len = sr * 2;
              const hissBuf = ctx.createBuffer(1, len, sr), popBuf = ctx.createBuffer(1, len, sr);
              const h = hissBuf.getChannelData(0), p = popBuf.getChannelData(0);
              let lp1 = 0, hp1 = 0, env = 0, sign = 1;
              for (let i = 0; i < len; i++) {
                lp1 += 0.45 * (Math.random() * 2 - 1 - lp1); hp1 += 0.025 * (lp1 - hp1);
                h[i] = (lp1 - hp1) * 0.5;
                if (Math.random() < 9 / sr) { env = 0.3 + 0.7 * Math.random(); sign = Math.random() < 0.5 ? -1 : 1; }
                p[i] = sign * env * 0.6; env *= 0.985;
              }
              const loop = (buf) => { const s = ctx.createBufferSource(); s.buffer = buf; s.loop = true; s.start(); return s; };
              r.hissGain = ctx.createGain(); r.hissGain.gain.value = 0; loop(hissBuf).connect(r.hissGain); r.hissGain.connect(r.master);
              r.popGain = ctx.createGain(); r.popGain.gain.value = 0; loop(popBuf).connect(r.popGain); r.popGain.connect(r.master);
              r.built = true;
            };
            // The static's level and the pops, eased.
            r.staticTo = (hiss, pops, tau) => {
              if (!r.built) return;
              const t = a.ctx.currentTime, k = r.effects ? 1 : 0;
              r.hissGain.gain.setTargetAtTime(hiss * 0.5 * k, t, tau);
              r.popGain.gain.setTargetAtTime(pops * 0.4 * k, t, tau);
            };
            r.sweep = () => {
              if (!r.built || !r.effects) return;
              const ctx = a.ctx, t = ctx.currentTime, d = 0.65;
              const osc = ctx.createOscillator(), osc2 = ctx.createOscillator(), g = ctx.createGain();
              osc.type = 'sine'; osc2.type = 'sine';
              osc.frequency.setValueAtTime(380, t); osc.frequency.linearRampToValueAtTime(2780, t + d / 2); osc.frequency.linearRampToValueAtTime(380, t + d);
              osc2.frequency.setValueAtTime(180, t); osc2.frequency.linearRampToValueAtTime(1080, t + d / 3); osc2.frequency.linearRampToValueAtTime(260, t + d);
              g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(0.28, t + d / 2); g.gain.linearRampToValueAtTime(0, t + d);
              osc.connect(g); osc2.connect(g); g.connect(r.master);
              osc.start(t); osc2.start(t); osc.stop(t + d + 0.05); osc2.stop(t + d + 0.05);
            };
            r.stopEl = () => {
              if (r.el) { try { r.el.pause(); r.el.removeAttribute('src'); r.el.load(); } catch (e) {} }
              if (r.src) { try { r.src.disconnect(); } catch (e) {} r.src = null; }
              r.el = null;
            };
          }
          r.build();
          const gen = ++r.gen;
          r.stopEl();
          r.music.gain.cancelScheduledValues(a.ctx.currentTime); r.music.gain.setValueAtTime(0, a.ctx.currentTime);
          r.staticTo(0.9, 0.8, 0.05);
          r.sweep();
          const list = urls.split('\n');
          let i = 0;
          const attempt = (cors) => {
            if (r.gen !== gen) return;
            if (i >= list.length) { r.staticTo(0.55, 0.8, 0.1); status('failed:The station does not answer.'); return; }
            const el = new Audio();
            if (cors) el.crossOrigin = 'anonymous';
            el.preload = 'auto';
            el.src = list[i];
            r.el = el;
            let routed = false;
            el.addEventListener('playing', () => {
              if (r.gen !== gen) return;
              const ctx = a.ctx;
              if (cors && !routed && r.effects) {
                routed = true;
                r.src = ctx.createMediaElementSource(el); r.src.connect(r.hp);
                // Silent through the whistle, then up over a quarter of a second.
                const t = ctx.currentTime + 0.65;
                r.music.gain.cancelScheduledValues(ctx.currentTime); r.music.gain.setValueAtTime(0, ctx.currentTime);
                r.music.gain.setValueAtTime(0, t); r.music.gain.linearRampToValueAtTime(1, t + 0.3);
                el.volume = 1;
              } else {
                // No filter possible (no CORS): the element plays plainly at the radio's volume.
                el.volume = r.volume;
              }
              r.staticTo(0.1, 0.25, 0.6);
              status('playing');
            });
            el.addEventListener('waiting', () => { if (r.gen === gen) r.staticTo(0.6, 0.8, 0.1); });
            el.addEventListener('error', () => {
              if (r.gen !== gen) return;
              if (cors) { attempt(false); } else { i++; attempt(true); }
            });
            el.play().catch(() => {});
          };
          attempt(true);
        },
    'app.thetypist.core.audio.radio.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'app.thetypist.core.audio.radio.jsRadioStop' : () => {
          const r = globalThis.__typistRadio;
          if (!r) return;
          r.gen++;
          r.stopEl();
          if (r.built) { const t = globalThis.__typistAudio.ctx.currentTime; r.music.gain.cancelScheduledValues(t); r.music.gain.setTargetAtTime(0, t, 0.1); r.staticTo(0, 0, 0.15); }
        },
    'app.thetypist.core.audio.radio.jsRadioVolume' : (volume) => {
          const r = globalThis.__typistRadio;
          if (!r) return;
          r.volume = volume;
          if (r.built) r.master.gain.setTargetAtTime(volume * volume * 0.9, globalThis.__typistAudio.ctx.currentTime, 0.05);
          if (r.el && !r.src) r.el.volume = volume;
        },
    'app.thetypist.core.audio.radio.jsRadioEffects' : (on) => {
          const r = globalThis.__typistRadio;
          if (!r) return;
          r.effects = on;
          if (!on && r.built) r.staticTo(0, 0, 0.1);
        },
    'app.thetypist.core.network.encode' : (value) => encodeURIComponent(value),
    'app.thetypist.core.network.jsFetch' : (url, method, headerLines, body, done) => {
          const store = globalThis.__typistHttp || (globalThis.__typistHttp = { next: 0, bodies: {} });
          const headers = {};
          for (const line of headerLines.split('\n')) { const i = line.indexOf(': '); if (i > 0) headers[line.slice(0, i)] = line.slice(i + 2); }
          fetch(url, { method, headers, body: body == null ? undefined : body })
            .then(r => r.arrayBuffer().then(buffer => { const slot = store.next++; store.bodies[slot] = new Uint8Array(buffer); done(slot, r.status, null); }))
            .catch(e => done(-1, 0, String((e && e.message) || e)));
        },
    'app.thetypist.core.network.__convertKotlinClosureToJsClosure_((Int,Int,String?)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Int,Int,String?)->Unit)'](f, p0, p1, p2)),
    'app.thetypist.core.network.jsLength' : (slot) => globalThis.__typistHttp.bodies[slot].length,
    'app.thetypist.core.network.jsByte' : (slot, index) => globalThis.__typistHttp.bodies[slot][index],
    'app.thetypist.core.network.jsFree' : (slot) => { delete globalThis.__typistHttp.bodies[slot]; },
    'app.thetypist.core.account.pageQuery' : () => globalThis.location.search,
    'app.thetypist.core.account.cleanPageAddress' : () => { try { globalThis.history.replaceState(null, '', globalThis.location.pathname); } catch (e) {} },
    'app.thetypist.core.account.goTo' : (url) => { globalThis.location.assign(url); },
    'app.thetypist.core.account.pageAddress' : () => globalThis.location.origin + globalThis.location.pathname,
    'app.thetypist.core.account.pageFragment' : () => globalThis.location.hash,
    'app.thetypist.core.account.cleanFragment' : () => { try { globalThis.history.replaceState(null, '', globalThis.location.pathname + globalThis.location.search); } catch (e) {} },
    'app.thetypist.core.weather.jsLocate' : (done) => {
          if (!navigator.geolocation) { done(false, 0, 0); return; }
          navigator.geolocation.getCurrentPosition(
            p => done(true, p.coords.latitude, p.coords.longitude),
            () => done(false, 0, 0),
            { enableHighAccuracy: false, timeout: 15000, maximumAge: 1800000 },
          );
        },
    'app.thetypist.core.weather.__convertKotlinClosureToJsClosure_((Boolean,Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Boolean,Double,Double)->Unit)'](f, p0, p1, p2)),
    'app.thetypist.game.jsPickAudio' : (onPicked) => {
          const input = document.createElement('input');
          input.type = 'file';
          input.multiple = true;
          input.accept = '.mp3,audio/mpeg';
          input.addEventListener('cancel', () => onPicked(''));
          input.onchange = async () => {
            const files = Array.from(input.files || []);
            const rows = await Promise.all(files.map(f => new Promise(resolve => {
              const url = URL.createObjectURL(f);
              const a = new Audio();
              a.preload = 'metadata';
              a.onloadedmetadata = () => resolve(f.name.replace(/[\t\n]/g, ' ') + '\t' + a.duration + '\t' + url);
              a.onerror = () => resolve('');
              a.src = url;
            })));
            onPicked(rows.filter(r => r).join('\n'));
          };
          input.click();
        },
    'app.thetypist.game.jsPickFile' : (onPicked) => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = '.epub,.txt,application/epub+zip,text/plain';
          input.addEventListener('cancel', () => onPicked(null, 0));
          input.onchange = async () => {
            const file = input.files && input.files[0];
            if (!file) { onPicked(null, 0); return; }
            globalThis.__typistPicked = new Uint8Array(await file.arrayBuffer());
            onPicked(file.name, globalThis.__typistPicked.length);
          };
          input.click();
        },
    'app.thetypist.game.__convertKotlinClosureToJsClosure_((String?,Int)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String?,Int)->Unit)'](f, p0, p1)),
    'app.thetypist.game.jsPickedByte' : (index) => globalThis.__typistPicked[index],
    'app.thetypist.game.jsSplashProgress' : (done, total) => {
          globalThis.__typistPreload = done + '/' + total;
          const line = document.querySelector('#splash .line');
          if (line && total > 0) line.firstChild.textContent = 'Rolling a sheet into the machine · ' + Math.floor(100 * done / total) + '% ';
        },
    'app.thetypist.game.web.jsAttended' : () => document.visibilityState === 'visible' && document.hasFocus(),
    'app.thetypist.game.web.jsUnlisten' : (id) => {
          const w = globalThis;
          const handler = w.__typistPageFocus && w.__typistPageFocus[id];
          if (!handler) return;
          w.removeEventListener('blur', handler);
          w.removeEventListener('focus', handler);
          document.removeEventListener('visibilitychange', handler);
          delete w.__typistPageFocus[id];
        },
    'app.thetypist.game.web.jsSuspendSound' : (suspended) => {
          const ctx = globalThis.__typistAudio && globalThis.__typistAudio.ctx;
          if (!ctx) return;
          if (suspended) ctx.suspend(); else ctx.resume();
        },
    'app.thetypist.game.web.jsAddListeners' : (id, onChange) => {
          const w = globalThis;
          w.__typistPageFocus = w.__typistPageFocus || {};
          const handler = () => onChange();
          w.__typistPageFocus[id] = handler;
          w.addEventListener('blur', handler);
          w.addEventListener('focus', handler);
          document.addEventListener('visibilitychange', handler);
        },
    'liftSplash' : () => {
          const splash = document.getElementById('splash');
          if (!splash) return;
          splash.style.opacity = '0';
          setTimeout(() => splash.remove(), 400);
        }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    